module.exports = __webpack_public_path__ + "static/media/banner01.893a98ac.png";